/**
 * Whether a page gated on `pageCodes` is visible to someone holding `heldCodes` — the editor's
 * "Preview as" lens only; end-user pages are filtered server-side.
 *
 * 🔴 The empty set means visible to everyone, and that branch comes first: an intersection with an empty
 * set is empty, which would read as hidden. Do not use `AuthorizationService.hasPermission` for this — it
 * passes admins unconditionally and its lenient branch returns false on `[]`.
 */
export function isPageVisibleTo(pageCodes: Array<string> | null | undefined, heldCodes: Set<string>): boolean {
  if (!pageCodes?.length) {
    return true;
  }
  return pageCodes.some(code => heldCodes.has(code));
}
